export const Logo = () => (
  <a href="#top" data-testid="navbar-logo" className="leading-none">
    <span className="block font-display text-xl font-extrabold uppercase tracking-wide text-white">Bennett</span>
    <span className="block font-display text-xs font-extrabold uppercase tracking-[0.35em] text-white">Custom Builders</span>
  </a>
);
